import {useWindowSize} from './window-size';

type Orientation = 'horizontal' | 'vertical' | 'none';

export function useOrientation(defaultValue: Orientation = 'none'): Orientation {
    const [innerWidth, innerHeight] = useWindowSize();
    if (innerWidth === 1024 && innerHeight === 600) {
        return 'horizontal';
    }
    if (innerWidth === 600 && innerHeight === 1024) {
        return 'vertical';
    }

    return defaultValue;
}
